import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import PublicSiteHeader from '@components/layout/PublicSiteHeader';
import SiteFooter from '@components/layout/SiteFooter';
import { brandColors } from '@config/brandTokens';

interface PublicContentPageShellProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  /** Default lg. Use false / xl for wide tables (e.g. motor comparison). */
  maxWidth?: false | 'sm' | 'md' | 'lg' | 'xl';
}

/** Shared layout for public knowledge pages (Motor, Fitness, Blogs). */
const PublicContentPageShell: React.FC<PublicContentPageShellProps> = ({
  title,
  subtitle,
  children,
  maxWidth = 'lg',
}) => (
  <Box sx={{ minHeight: '100vh', bgcolor: brandColors.ice, display: 'flex', flexDirection: 'column' }}>
    <PublicSiteHeader />
    <Container
      maxWidth={maxWidth}
      sx={{
        py: { xs: 2.5, md: 3 },
        flex: 1,
        width: '100%',
        px: { xs: 1.5, sm: 2, md: 3 },
      }}
    >
      <Typography
        component="h1"
        sx={{
          fontFamily: '"Sora", Arial, sans-serif',
          fontWeight: 800,
          fontSize: { xs: '1.55rem', md: '1.85rem' },
          color: brandColors.navy,
          mb: 0.75,
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          sx={{
            color: brandColors.slate,
            fontSize: '0.98rem',
            lineHeight: 1.55,
            maxWidth: maxWidth === false || maxWidth === 'xl' ? 960 : 820,
            mb: 2,
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
      {children}
    </Container>
    <SiteFooter />
  </Box>
);

export default PublicContentPageShell;
